<template>
  <HvhContextMenu :event="$store.state.rightClickEvent.event">
    <li @click="open">
      <label>Open</label>
    </li>
    <li @click="openInNewTab">
      <label>Open link in new tab</label>
    </li>
    <!-- <li @click="openInNewWindow">
      <label>Open link in new window</label>
    </li> -->
  </HvhContextMenu>
</template>

<script>
import HvhContextMenu from './HvhContextMenu.vue';
export default {
  components: { HvhContextMenu },
  computed: {
    link() {
      return this.$store.state.rightClickEvent.link;
    },
  },
  methods: {
    open() {
      window.open(this.link, '_self');
    },
    openInNewTab() {
      window.open(this.link, '_blank');
    },
    openInNewWindow() {
      window.open(this.link, '_blank', 'location=yes,scrollbars=yes,status=yes');
    },
  },
}
</script>